import { GetProposalQuery } from '@/gql/graphql';

type Proposal = GetProposalQuery['proposal'];

/**
 * Where a Proposal stands once it has been sent. A Draft has none.
 *
 * There is deliberately no expired state. The Provider schema exposes no
 * expiry, and deriving one here from `sentAt` and `validForDays` would
 * disagree with the backend, which resolves it to end of day in the Account's
 * region timezone.
 */
export type SentProposalStatus = 'sent' | 'bounced' | 'accepted' | 'declined';

export type SentProposalStatusFields = Pick<
  Proposal,
  'sentAt' | 'bouncedAt' | 'acceptedAt' | 'declinedAt'
>;

/** Null while the Proposal is still a Draft. */
export const getSentProposalStatus = (
  proposal: SentProposalStatusFields | undefined
): SentProposalStatus | null => {
  if (!proposal?.sentAt) return null;
  // A decision outranks a delivery failure: the Customer answered in spite of
  // it, so what the reader needs to know is the answer.
  if (proposal.acceptedAt) return 'accepted';
  if (proposal.declinedAt) return 'declined';
  if (proposal.bouncedAt) return 'bounced';
  return 'sent';
};
